
export function useRooms() {
  const rooms = []
   const isLoading = false
   const error = false

  return { rooms, isLoading, error };
}
